import { Component, HostListener, OnInit } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { Subject } from 'rxjs/Subject';
import { SearchResult } from '../../../../search/search-result';
import { SearchService } from '../../../../search/search.service';

@Component({
    selector: 'chassis-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
    private searchTerms = new Subject<string>();
    private searchResult: SearchResult;

    constructor(private searchService: SearchService) {
    }

    @HostListener('document:keyup', ['$event'])
    onDocumentKeyUp(keyEvent) {
        // console.log(keyEvent);

        // Check which button is pressed
        switch (keyEvent.key) {
            case 'Escape': { // ESC
                if (this.searchService.visible) {
                    this.closeSearchOverlay();
                }

                break;
            }
            // case 's': // s
            // case 'S': // S (in case of CAPS on)
            // case '/':
            // {
            //     if (!this.searchService.visible) {
            //         this.showSearchOverlay();
            //     }
            //
            //     break;
            // }
            default : {
                break;
            }
        }
    }

    onOverlaySearchKeyUp(event: any) {
        this.addSearchTerm(event.target.value);
    }

    addSearchTerm(term: string) {
        this.searchTerms.next(term);
    }

    closeSearchOverlay() {
        this.clearSearch();
        this.hideOverlay();
    }

    clearSearch() {
        this.searchTerms  = new Subject<string>();
        this.searchResult = null;
    }

    showSearchOverlay() {
        this.searchService.visible = true;
    }

    hideOverlay() {
        this.searchService.visible = false;
    }

    ngOnInit() {
        this.searchTerms
            .debounceTime(500) // wait 500ms after each keystroke before considering the term
            .distinctUntilChanged() // ignore is nothing has changed
            .switchMap(term => { // switch to a new Observable each time the term changes
                if (term) {
                    return this.searchService.search(term); // return the http search observable
                }

                return Observable.of<SearchResult>();
            })
            .catch(error => {
                console.log(error);
                return Observable.of<SearchResult>();
            })
            .subscribe(result => this.searchResult = result);
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/layouts/components/partials/search/search.component.ts